/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useState, useEffect } from 'react';
import { Button } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import _ from 'lodash';
import { MenuItem, TextField } from '@material-ui/core';
import Spinner from '../../../../SharedModules/Spinner/Spinner';
import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';
import RadioGroupComponent from '../../../../SharedModules/RadioGroup/RadioGroupBtn';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';

// variables custom Import
import * as commonConstant from '../../../../SharedModules/CommonConstants/commonConstants';
import DisplayErrorMessages from '../../../../SharedModules/Errors/ErrorMessages';
import {
  autoFormateDate,
  tabHighLigther,
} from '../../../../SharedModules/utilities/utilities';

import {
  STATUS_MSG,
  SUCCESS_MSG,
  REBATE_PROGRAM_REQUIRED,
  VALIDATE_QUARTER_VALUE,
  QUARTER_VALUE_REQUIRED,
} from '../../../../SharedModules/Errors/constantMessageData';
import {
  handleScrollToEvent,
  quarterTest1,
  quarterTest2,
} from '../../../../SharedModules/CommonUtilities/commonUtilities';
import {
  dispatchErrorMsgFamilyPlanningDrugsInv,
  getPlanTypeValues,
  getRebateProgrameList,
  familyPlanningDrugsInvSearchObj,
  setRebatePrograme,
  dispatchRebatePrograme,
  dispatchQtrValue,
  getFamilyPlanningDrugsInvData,
  dispatchDisplayFamilyInv,
} from '../Store/Actions';
import { clearReduxForFilterAndSort } from '../../../../SharedModules/Table/store/Actions';

const ReqFamilyPlanningDrugsInv = (props) => {
  // initial states
  const dispatch = useDispatch();
  const navigateToRequest = '/familyPlanningDrugsInvoicedforRebates';
  const [radioList, setRadioList] = React.useState([]);
  const [rebateProgramList, setRebateProgramList] = React.useState([]);

  // current Quarter
  const currentDate = new Date();
  const currentMonth = currentDate.getMonth() + 1; // Month is zero-indexed, so add 1
  const currentYear = currentDate.getFullYear();
  const currentQuarter = Math.ceil(currentMonth / 3); // Divide the current month by 3 and round up to get the current quarter
  const formattedQuarter = `${currentQuarter}Q${currentYear.toString()}`;
  const [quarterValue, setQuarterValue] = React.useState(formattedQuarter);
  const [isSearchClicked, setSearchClicked] = React.useState(false);

  // use Selector function

  const userDefaults = useSelector(
    (state) => state?.sharedState?.UserDefaultReducer?.UserDefaultsValues?.data
  );
  const requestFamilyPlanningDrugsInvScreenData = useSelector(
    (state) =>
      state?.sharedState?.FamilyPlanningDrugsInvReducer
        ?.familyPlanningDrugsInvSearchObj
  );
  const { quarterValue: quarterValues } = useSelector(
    (state) => state?.sharedState?.FamilyPlanningDrugsInvReducer
  );
  const planTypeList = useSelector(
    (state) => state?.sharedState?.FamilyPlanningDrugsInvReducer?.planType
  );
  const rebateProgramValue = useSelector(
    (state) =>
      state?.sharedState?.FamilyPlanningDrugsInvReducer?.setRebateProgram
  );
  const getRebateProgramList = useSelector(
    (state) => state?.sharedState?.FamilyPlanningDrugsInvReducer?.rebateProgram
  );

  const getErrorMsg = useSelector(
    (state) =>
      state?.sharedState?.FamilyPlanningDrugsInvReducer
        ?.errorMsgFamilyPlanningDrugsInv
  );
  const getSearchResult = useSelector(
    (state) => state?.sharedState?.FamilyPlanningDrugsInvReducer?.searchResult
  );
  const isLoading = useSelector(
    (state) => state?.sharedState?.FamilyPlanningDrugsInvReducer?.isLoading
  );

  // states with initial values
  const [state, setState] = React.useState(
    requestFamilyPlanningDrugsInvScreenData?.state
      ? requestFamilyPlanningDrugsInvScreenData?.state
      : {
          planTypeCd: userDefaults?.planTypeCd
            ? userDefaults?.planTypeCd
            : 'FD',
          rebateProgramCd:
            rebateProgramValue || userDefaults?.rebateProgramCd
              ? userDefaults?.rebateProgramCd
              : '-1',
          quarterValue: quarterValue,
        }
  );

  // dispatch function
  const setFamilyPlanningDrugsInvSearchObj = (value) =>
    dispatch(familyPlanningDrugsInvSearchObj(value));

  // converting date to required payload
  function getQuarterDates(quarter) {
    const year = parseInt(quarter.slice(-4));
    const quarterNum = parseInt(quarter.slice(0, 1));
    let startDate;
    let endDate;

    switch (quarterNum) {
      case 1:
        startDate = new Date(year, 0, 1);
        endDate = new Date(year, 2, 31);
        break;
      case 2:
        startDate = new Date(year, 3, 1);
        endDate = new Date(year, 5, 30);
        break;
      case 3:
        startDate = new Date(year, 6, 1);
        endDate = new Date(year, 8, 30);
        break;
      case 4:
        startDate = new Date(year, 9, 1);
        endDate = new Date(year, 11, 31);
        break;
    }

    const options = { month: '2-digit', day: '2-digit', year: 'numeric' };
    const startStr = startDate?.toLocaleDateString('en-US', options);
    const endStr = endDate?.toLocaleDateString('en-US', options);

    return { startDate: startStr, endDate: endStr };
  }
  const qtr = getQuarterDates(quarterValue);

  // Plan type useEffect
  React.useEffect(() => {
    handleScrollToEvent();
    if (!planTypeList?.PLAN_TYPE_CD) {
      dispatch(getPlanTypeValues({}));
    }
  }, []);

  //  setting radioList from planList Api
  React.useEffect(() => {
    if (
      planTypeList &&
      planTypeList.PLAN_TYPE_CD &&
      planTypeList.PLAN_TYPE_CD.length > 0
    ) {
      const planList = planTypeList.PLAN_TYPE_CD.map((obj) => {
        return {
          name:
            obj.codeValueID.codeValue === 'FD'
              ? 'Medicaid'
              : obj.shortDescription,
          value: obj.codeValueID.codeValue,
        };
      });
      setRadioList([
        ...planList.filter((obj) => obj.name === 'Medicaid'),
        ...planList.filter((obj) => obj.name !== 'Medicaid'),
      ]);
    }
  }, [planTypeList]);

  // set Rebate Program List

  const rebatepgmDropdown = async (planType) => {
    const getRebateProgramList = await dispatch(
      getRebateProgrameList(state.planTypeCd)
    );
    let list = [];
    if (
      getRebateProgramList?.status === STATUS_MSG &&
      getRebateProgramList?.message === SUCCESS_MSG
    ) {
      if (!_.isEmpty(getRebateProgramList.data)) {
        list = _.map(getRebateProgramList.data, (val) => ({
          ...val,
          id: val.rebateProgramCd,
          name: `${val.rebateProgramCd} | ${val.shortDescr}`,
        }));
      }
    }
    setRebateProgramList(
      list.sort((key, val) =>
        key.name.toLowerCase().localeCompare(val.name.toLowerCase())
      )
    );
  };

  // set rebate program
  React.useEffect(() => {
    if (state.planTypeCd) {
      rebatepgmDropdown(state.planTypeCd);
    }
  }, [state.planTypeCd]);

  //Resetting Error message on input change
  React.useEffect(() => {
    dispatch(dispatchErrorMsgFamilyPlanningDrugsInv([]));
  }, [state.planTypeCd, state.rebateProgramCd, state.quarterValue])
  
  // handle- onchange functionality

  const handleOnChangeEvent = (value, name) => {
    if (name === 'planTypeCd') {
      setState({ ...state, [name]: value, rebateProgramCd: '-1' });
      setFamilyPlanningDrugsInvSearchObj({
        state: { ...state, [name]: value, rebateProgramCd: '-1' },
      });
    }
    if (name === 'rebateProgramCd') {
      setState({ ...state, [name]: value });
      setFamilyPlanningDrugsInvSearchObj({
        state: { ...state, [name]: value },
      });
    }

    if (name === 'quarterValue') {
      setState({ ...state, [name]: value });
      setFamilyPlanningDrugsInvSearchObj({
        state: { ...state, [name]: value },
      });
    }
  };

  // on blur functionality on field level
  const handleOnblurEvent = (type, value) => {
    let localErr = getErrorMsg || [];
    const data = value;

    if (type === 'rebateProgramCd') {
      localErr = localErr.filter((item) => item.field !== 'rebateProgramCd');
    }

    if (type === 'quarterValue') {
      if (data && !_.isEmpty(data)) {
        const indexOf = !_.isEmpty(localErr)
          ? _.findIndex(localErr, {
              field: 'quarter',
              errorType: 'required',
            })
          : null;

        if (!_.isNull(indexOf) && indexOf >= 0) {
          localErr.splice(indexOf, 1);
        }
        if (quarterTest1.test(data) || quarterTest2.test(data)) {
          const indexOf = !_.isEmpty(localErr)
            ? _.findIndex(localErr, {
                field: 'quarter',
                errorType: 'invalidFormat',
              })
            : null;

          if (!_.isNull(indexOf) && indexOf >= 0) {
            localErr.splice(indexOf, 1);
          }
          localErr = localErr.filter((item) => item.field !== 'quarter');
          setState({
            ...state,
            quarterValue: autoFormateDate(value?.toUpperCase()),
          });
          setFamilyPlanningDrugsInvSearchObj({
            state: {
              ...state,
              quarterValue: autoFormateDate(value?.toUpperCase()),
            },
          });
        } else {
          localErr = localErr.filter((item) => item.field !== 'quarter');
          localErr.push({
            field: 'quarter',
            errorType: 'invalidFormat',
            message: VALIDATE_QUARTER_VALUE,
          });
        }
      } else {
        localErr = localErr.filter((item) => item.field !== 'quarter');
        localErr.push({
          field: 'quarter',
          errorType: 'required',
          message: QUARTER_VALUE_REQUIRED,
        });
      }
    }
    const unique = [...new Set(localErr)];
    dispatch(dispatchErrorMsgFamilyPlanningDrugsInv(unique));
  };

  //  tab highliter Functionality
  React.useEffect(() => {
    if (getErrorMsg && getErrorMsg.length > 0) {
      tabHighLigther(navigateToRequest, true);
    } else {
      tabHighLigther(navigateToRequest, false);
    }
  }, [JSON.stringify(getErrorMsg)]);

  // Search button on click functionality
  const onClickOnSearch = () => {
    const rebateProgramName = rebateProgramList.find(
      (item) => item.id == state.rebateProgramCd
    )?.rebateProgramCd;
    let localErr = getErrorMsg || [];
    if (getErrorMsg.length > 0) {
    } else if (state.rebateProgramCd === '-1') {
      localErr = localErr.filter((item) => item.field !== 'rebateProgramCd');
      localErr.push({
        field: 'rebateProgramCd',
        errorType: 'rebateRequired',
        message: REBATE_PROGRAM_REQUIRED,
      });
    } else {
      localErr = localErr?.filter((item) => item.field !== 'rebateProgramCd');
    }
    const unique = [...new Set(localErr)];
    dispatch(dispatchErrorMsgFamilyPlanningDrugsInv(unique));

    if (state.rebateProgramCd != '-1' && quarterTest1.test(quarterValue)) {
      setSearchClicked(true);
      // Variable to get fullname of rebate program from rebate program list(selectList)
      let rebateProgrameName =
        rebateProgramList.find(
          (item) => item.rebateProgramCd === rebateProgramName
        ) || {};
      rebateProgrameName = `${rebateProgrameName?.rebateProgramCd} - ${
        rebateProgrameName?.shortDescr || ''
      }`;
      dispatch(setRebatePrograme(rebateProgramName));
      dispatch(dispatchQtrValue(state.quarterValue));
      dispatch(
        dispatchDisplayFamilyInv({
          displayObj: {
            setRebateProgram: rebateProgramName,
            rebateProgrameName,
            quarter: state.quarterValue,
            rebateProgram: getRebateProgramList,
            planType: planTypeList,
          },
        })
      );
      dispatch(
        getFamilyPlanningDrugsInvData({
          rebateProgramCd: state.rebateProgramCd,
          quarter: state.quarterValue,
          beginDate: qtr.startDate,
          endDate: qtr.endDate,
        })
      );
    }
  };

  if (isSearchClicked && getSearchResult?.length > 0) {
    setSearchClicked(false);
    props.history.push({
      pathname: '/DisplayFamilyPlanningDrugsInvoicedRebates',
    });
    dispatch(
      clearReduxForFilterAndSort('/DisplayFamilyPlanningDrugsInvoicedRebates')
    );

    const updateTabs =
      JSON.parse(localStorage.getItem('tabItemsData')) === null
        ? []
        : JSON.parse(localStorage.getItem('tabItemsData'));
    updateTabs.push({
      navTo: '/DisplayFamilyPlanningDrugsInvoicedRebates',
      value: 'Display Family Planning Drugs Inv',
    });
    localStorage.setItem('tabItemsData', JSON.stringify(updateTabs));
  }

  return (
    <div className="tabs-container">
      <Spinner load={isLoading} />
      <CustomSeparator
        parent1="State Reports"
        parent2="Req Family Planning Drugs Inv"
      />
      {getErrorMsg?.length > 0 ? (
        <DisplayErrorMessages
          errorMessages={[
            ...new Set(
              getErrorMsg?.length > 0
                ? _.map(getErrorMsg, (l) => l.message)
                : []
            ),
          ]}
        />
      ) : null}
      <div className="tab-body">
        <div className="row">
          <div className="col-4 frr-two-col-radio">
            <RadioGroupComponent
              id="filter-plan-by-radio-btn-action"
              data-testid="FPDI-PlanType"
              labelName={commonConstant.radioGroupLabelNamePlan}
              required={false}
              optionList={radioList || []}
              defaultValue={state && state.planTypeCd}
              filterAction={(e) => {
                handleOnChangeEvent(e, 'planTypeCd');
              }}
              className="log-batch-filter-radio frr-checkInvoiceRadio"
            />
          </div>

          <div className="col-4 frr-two-col-radio ">
            <fieldset className="custom-fieldset">
              <legend className="same-font-family">
                Rebate Program <span className="mandatory"> *</span>
              </legend>
              <div className="form-wrapper p-3">
                <div className="mui-custom-form with-select field-xl no-lbl">
                  <TextField
                    id="rebate_program"
                    data-testid="FPDI-Rebate-Profram"
                    label={commonConstant.rebateProgramLabelName}
                    fullWidth
                    select
                    required
                    placeholder=""
                    inputProps={{ maxLength: 11, id: 'rebate_program' }}
                    onBlur={(e) =>
                      handleOnblurEvent('rebateProgramCd', e.target.value)
                    }
                    InputLabelProps={{
                      shrink: true,
                    }}
                    value={state && state.rebateProgramCd}
                    onChange={(e) =>
                      handleOnChangeEvent(e.target.value, 'rebateProgramCd')
                    }
                    className={
                      getErrorMsg?.length > 0
                        ? _.map(getErrorMsg, (l) =>
                            l.field === 'rebateProgramCd'
                              ? 'mandate-fields'
                              : null
                          )
                        : null
                    }
                    helperText={
                      getErrorMsg?.length > 0
                        ? _.map(getErrorMsg, (l) =>
                            l.field === 'rebateProgramCd' ? l.message : null
                          )
                        : null
                    }
                    error={
                      getErrorMsg?.length > 0
                        ? _.map(getErrorMsg, (l) =>
                            l.field === 'rebateProgramCd' ? l.message : null
                          )
                        : null
                    }
                  >
                    <MenuItem
                      key=""
                      value="-1"
                      className="frr-dropdown-blank-item"
                    />
                    {rebateProgramList?.length > 0
                      ? rebateProgramList.map((item) => {
                          return (
                            <MenuItem key={item.id} value={item.id}>
                              {item.name}
                            </MenuItem>
                          );
                        })
                      : null}
                  </TextField>
                </div>
              </div>
            </fieldset>
          </div>
          <div className="col-4">
            <fieldset className="custom-fieldset">
              <legend className="same-font-family">
                Quarter<span className="mandatory"> *</span>
              </legend>
              <div
                className="mui-custom-form with-select"
                style={{ marginTop: '8px' }}
              >
                <TextField
                  id="check_by_invoice_quater"
                  label="Quarter"
                  required
                  fullWidth
                  placeholder=""
                  data-testid="FPDI-Quarter"
                  inputProps={{ maxLength: 6, id: 'check_by_invoice_quater' }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  value={state && state.quarterValue}
                  onChange={(e) => {
                    handleOnChangeEvent(e.target.value, 'quarterValue');
                  }}
                  className={
                    getErrorMsg?.length > 0
                      ? _.map(getErrorMsg, (l) =>
                          l.field == 'quarter'
                            ? 'mandate-fields frr-display-hidden-label'
                            : 'frr-display-hidden-label'
                        )
                      : 'frr-display-hidden-label'
                  }
                  onBlur={(e) =>
                    handleOnblurEvent('quarterValue', e.target.value)
                  }
                  helperText={
                    getErrorMsg?.length > 0
                      ? _.map(getErrorMsg, (l) =>
                          l.field === 'quarter' ? l.message : null
                        )
                      : null
                  }
                  error={
                    getErrorMsg?.length > 0
                      ? _.map(getErrorMsg, (l) =>
                          l.field == 'quarter' ? l.message : null
                        )
                      : null
                  }
                />
              </div>
            </fieldset>
          </div>
        </div>

        <div className="row">
          <div className="col-12 btn-wrapper mb-2">
            <div className="float-right mt-2 hide-on-print">
              <Button
                className="btn btn-success btn-search"
                data-testid="view_detail_ia"
                type="button"
                onClick={onClickOnSearch}
              >
                {' '}
                <SVGComponent iconName="Icon-search" /> {'  '} Search
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReqFamilyPlanningDrugsInv;
